import type { IItemFragility, IItemCategory } from '../types';

export const fragilityTypes: IItemFragility[] = [
  { id: 0, label: 'FORM.FRAGILITY_ONE' },
  { id: 1, label: 'FORM.FRAGILITY_TWO' },
  { id: 2, label: 'FORM.FRAGILITY_THREE' },
];

export const categories: IItemCategory[] = [
  {
    id: 'a',
    label: 'FORM.CATEGORY_A',
  },
  {
    id: 'b',
    label: 'FORM.CATEGORY_B',
  },
  {
    id: 'c',
    label: 'FORM.CATEGORY_C',
  },
  {
    id: 'd',
    label: 'FORM.CATEGORY_D',
  },
  {
    id: 'e',
    label: 'FORM.CATEGORY_E',
  },
  {
    id: 'h',
    label: 'FORM.CATEGORY_H',
  },
  {
    id: 'i',
    label: 'FORM.CATEGORY_I',
  },
  {
    id: 'j',
    label: 'FORM.CATEGORY_J',
  },
  {
    id: 'k',
    label: 'FORM.CATEGORY_K',
  },
];
